import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import Slider from 'react-slick';
import 'react-calendar/dist/Calendar.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {calendariodata, calendariodataescuela} from '../../../utils';
import Card from '../../ui/card'
import Cardescuela from '../../ui/cardescuela'
import './index.css';


function Article({variant}) {
  const [date, setDate] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = React.createRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (variant) {
          const result = await calendariodata(variant);
          setData(result);
        } else {
          const [data1, data2] = await Promise.all([
            calendariodata(null),
            calendariodataescuela()
          ]);
          const combinedData = [...data1, ...data2];
          combinedData.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
          setData(combinedData);
        }
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [variant]);

  function parseDateAsUTC(dateString) {
    const date = new Date(dateString + 'T12:00:00Z');
    return date;
  }
  const onDateChange = date => {
    setDate(date);
    const index = data.findIndex(event => parseDateAsUTC(event.fecha).toDateString() === date.toDateString());
    if (index !== -1 && sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  if (loading || !data.length) {
    return <div></div>;
  }

  const settings = {
    dots: variant ? true : false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
  };

  // const data = calendariodata(variant);
  const activeDates = data.map(event => parseDateAsUTC(event.fecha));

  const next = () => {
    sliderRef.current.slickNext();
  };
  const previous = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className='columns calendario'>
      <div className='col col1'>
        <h4>Sumate a los encuentros</h4>
        <h5>Seleccioná una fecha<br />para conocer las reuniones</h5>
        <Calendar
          onChange={onDateChange}
          value={date}
          defaultView="month"
          activeStartDate={parseDateAsUTC(data[0].fecha)}
          // activeStartDate={parseDateAsUTC(data[data.length-1].fecha)}
          locale="es-ES"
          minDetail="month"
          prevLabel={<span>‹</span>}
          nextLabel={<span>›</span>}
          maxDate={parseDateAsUTC(data[0].fecha)}
          minDate={parseDateAsUTC(data[data.length-1].fecha)}
          tileDisabled={({ date }) => !activeDates.some(d => d.toDateString() === date.toDateString())}
        />
      </div>
      <div className='col col2'>
        <h4 className='title-ico'><i></i><span>Encuentros en los que participamos:</span></h4>
        <div className="cards">
          <Slider  ref={sliderRef} {...settings}>
            {data.map((item) =>
              item.escuela ? <Cardescuela key={item.id} data={item} /> : <Card key={item.id} data={item} />
            )}
          </Slider>
          {!variant && <div className='slick-buttons'>
            <button onClick={previous}><span>‹</span></button>
            <button onClick={next}><span>›</span></button>
          </div>}
        </div>
      </div>
    </div>
  );
}

export default Article;
